import { useState } from 'react';
import { IconText } from './Amount';
import CollapsedCard from './CollpasedCard';
const { Modal } = require('react-bootstrap');
const CardConverter = require('@tta/engine/Utilities/Converters/CardConverter');

// Offering a pact: a button per pact card; choosing it shows every rival with the ways it can be offered to them (for
// a one-sided pact, which side the offerer takes), spelling out who gets what, and a warning when accepting it would
// end the offerer's pact in play.
function PactActions({Category, ButtonClass, GameEngine, Hand})
{
    const [choosing, setChoosing] = useState(null);
    const cards = [];
    Category.options.forEach(option => {
        const entry = cards.find(c => c.id === option.choiceOf.id);
        if (entry)
        {
            entry.options.push(option);
        } else {
            cards.push({ id: option.choiceOf.id, label: option.choiceOf.label, options: [option] });
        }
    });
    return (
        <div className="tta-action-line" title={Category.title}>
            <span className="tta-action-title">{Category.label}:</span>
            {cards.map(card =>
                <button key={card.id} className={ButtonClass} disabled={card.options.every(option => option.disabled)}
                    onClick={() => setChoosing(card)}>
                    {card.label}
                </button>)}
            {choosing &&
                <PactPicker Card={Hand.find(c => c.id === choosing.id)} Label={choosing.label} Options={choosing.options}
                    Targets={GameEngine.GetPactTargets(choosing.id)} ButtonClass={ButtonClass}
                    OnCancel={() => setChoosing(null)}
                    OnChoose={(option) => { setChoosing(null); GameEngine.submitMove(option.move); }}/>}
        </div>
    );
}

export function PactPicker({Card, Label, Options, Targets, ButtonClass, OnChoose, OnCancel})
{
    return (
        <Modal show onHide={OnCancel} centered dialogClassName="tta-choice-dialog">
            <Modal.Header closeButton style={{ padding: '8px 12px' }}>
                <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>{Label}: offer to</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tta tta-left" style={{ padding: '12px' }}>
                {/* Above everything: the pact offered, and beside it, if accepting it would end the offerer's pact in play,
                    that one (hover for it); then the rivals */}
                <div className="tta-pact-offer-head">
                    {Card && <CollapsedCard card={Card}/>}
                    {Targets[0]?.ends &&
                        <div className="tta-target-warning tta-pact-ends">⚠ If accepted, ends your
                            <span className="tta-card-token"><CollapsedCard card={CardConverter(Targets[0].ends.card)}/></span>
                            with {Targets.find(t => t.player === Targets[0].ends.with)?.name ?? 'them'}</div>}
                </div>
                <div>
                    {/* A row per rival and way to offer it (one-sided: you as A or as B): what you get, what they get */}
                    <table className="tta-target-table">
                        <thead><tr><th>Rival</th><th>You</th><th>Them</th><th/></tr></thead>
                        <tbody>
                            {Targets.flatMap(target => target.roles.map((role, index) => {
                                const option = Options.find(o => o.move.target === target.player && o.move.offererIsA === role.offererIsA);
                                const oneSided = target.roles.length > 1;
                                return (
                                    <tr key={`${target.player} ${role.offererIsA}`}>
                                        <td>{index === 0 && <b>{target.name}</b>}</td>
                                        <td className="tta-pact-terms">{oneSided && <span className="tta-pact-side">{role.offererIsA ? 'A' : 'B'}</span>}<IconText text={role.you}/></td>
                                        <td className="tta-pact-terms">{oneSided && <span className="tta-pact-side">{role.offererIsA ? 'B' : 'A'}</span>}<IconText text={role.them}/></td>
                                        <td>
                                            <button className={ButtonClass} disabled={!option || option.disabled} title={option?.reason}
                                                onClick={() => OnChoose(option)}>Offer</button>
                                        </td>
                                    </tr>
                                );
                            }))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer className="tta" style={{ padding: '6px 12px' }}>
                <button className="tta-button" onClick={OnCancel}>Cancel</button>
            </Modal.Footer>
        </Modal>
    );
}

export default PactActions;
